module.exports = __webpack_public_path__ + "img/tema-3-10.4d67e52f.svg";